module.exports = __webpack_public_path__ + "static/og-image-c546e072baab580ba69107d86fa1f9c4.png";